import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Typography, TextField, MenuItem, FormControlLabel, Checkbox } from '@material-ui/core';
import OutlinedSelect from '../../../controls/OutlinedSelect';
import { grey } from '@material-ui/core/colors';

const styles = (theme) => ({
    section: {
        marginTop: theme.spacing(3),
    },
    subSection: {
        background: grey[100],
        padding: theme.spacing(3),
    },
});

class FormContent extends React.Component {
    handleChangeStep = (event) => {
        this.props.onChange(event.target.name, event.target.value);
    };

    handleChangeFacility = (event) => {
        this.props.onChange(event.target.name, event.target.checked);
    };

    render() {
        const forms = this.props.forms ? this.props.forms : [];
        return (
            <React.Fragment>
                <div className={this.props.classes.section}>
                    <Typography variant="body1" color="primary">
                        Step Text
                    </Typography>
                    <div className={this.props.classes.subSection}>
                        <TextField
                            name="text"
                            label="Text"
                            value={this.props.step.text}
                            margin="dense"
                            multiline
                            fullWidth
                            onChange={this.handleChangeStep}
                        />
                    </div>
                </div>
                <div className={this.props.classes.section}>
                    <Typography variant="body1" color="primary">
                        Select Facility
                    </Typography>
                    <div className={this.props.classes.subSection}>
                        <FormControlLabel
                            label="Select Facility"
                            control={
                                <Checkbox
                                    name="selectFacility"
                                    checked={this.props.step.selectFacility || false}
                                    onChange={this.handleChangeFacility}
                                />
                            }
                        />
                    </div>
                </div>
                <div className={this.props.classes.section}>
                    <Typography variant="body1" color="primary">
                        Linked Form
                    </Typography>
                    <div className={this.props.classes.subSection}>
                        <OutlinedSelect name={'form'} value={this.props.step.form} onChange={this.handleChangeStep}>
                            {forms.map((form) => (
                                <MenuItem key={form.id} value={form.id} fullWidth>
                                    {form.name}
                                </MenuItem>
                            ))}
                        </OutlinedSelect>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default withStyles(styles)(FormContent);
